import React from 'react';

const SelectItemButton = ({ isSelected, isIncluded, onAdd, onRemove, disabled, soldOut, isWait }) => {

  if (isWait) {
    return (
      <button
        className="extras-item__button field__input--selected"
        disabled="disabled"
      >
        Please wait...
      </button>
    );
  }

  if (isIncluded) {
    return (
      <button
        className="extras-item__button field__input--selected"
        onClick={() => {}}
        disabled={disabled}
      >
        Included
      </button>
    );
  }

  if (isSelected) {
    return (
      <button
        className="extras-item__button field__input--selected"
        onClick={onRemove}
        disabled={disabled}
      >
        Remove
      </button>
    );
  }

  if (soldOut) {
    return (
      <button className="extras-item__button" onClick={onAdd} disabled={disabled}>
        Sold Out
      </button>
    );
  }

  return (
    <button className="extras-item__button" onClick={onAdd} disabled={disabled}>
      Select
    </button>
  );
};

SelectItemButton.propTypes = {};

export default SelectItemButton;
